import React from 'react';
import { useMediaPredicate } from 'react-media-hook';

import { media } from 'utilities/browser';
import decodeHtml from 'utilities/decodeHtml';
import { ProductReviewRatingStars } from 'features/productReviews/components';
import { ProductItemShippingCallout } from 'features/product/components';

import ProductItemImage from '../ProductItemImage';
import ProductItemPrice from '../ProductItemPrice';

import ProductSortItemAddToCartButton from './components/ProductSortItemAddToCartButton';
import ProductSortItemCallouts from './components/ProductSortItemCallouts';
import './ProductSortItem.scss';

type ProductSortItemProps = {
	product: LP.product.ProductItem,
	sortPosition?: number,
	displayOptions?: LP.sort.ProductSortItemDisplayOptions,
	handleClickProduct?: (e: React.MouseEvent, product: LP.product.ProductItem) => void
};

function ProductSortItem ({
	product, sortPosition, displayOptions = {}, handleClickProduct
}: ProductSortItemProps) {

	const moreLikeThisUrl = `/more-like-this/${product.ShortSku}`;
	const isMediaDesktop = useMediaPredicate(media.DESKTOP);

	const {
		showAddToCart, showMoreLikeThis, showSaleCallout, showSavePrice, showShippingCallout, showJustForYouSaleCallout, showProductReviewRating
	} = displayOptions;

	const specialValuePriceText = '';
	const isSpecialValue = product.PriceText && product.PriceText === specialValuePriceText;
	const isHospitalityMode = window.lp.globals.isHospitality;
	const isProsMode = window.lp.globals.isProfessional;

	const showHospitalityPrice = isHospitalityMode && (product.HospitalityGrade || product.ConsumerListable);
	const showPrice = (!isHospitalityMode && !product.HospitalityGrade) || showHospitalityPrice;

	const showPriceCallout = (product.IsOpenBox && !product.PriceText)
		|| !isProsMode
		|| (isProsMode && isSpecialValue);

	const priceText = product.IsOpenBox && !product.PriceText
		? 'Open Box'
		: product.PriceText;

	return (
		<div className="ProductSortItem">
			<a className="ProductSortItem__link" href={product.ProductDetailUrl} data-slotId={product.SlotId} onClick={(e) => handleClickProduct && handleClickProduct(e, product)}>
				<ProductItemImage product={product} sortPosition={sortPosition}>
					<ProductSortItemCallouts product={product} />
				</ProductItemImage>
				<div className={`ProductSortItem__name ${showJustForYouSaleCallout ? 'ProductSortItem__name--sale' : ''}`}>
					{decodeHtml(product.ProductName)}
				</div>

				{showPrice && (
					<ProductItemPrice
						product={product}
						priceText={showPriceCallout && priceText}
						showSaleCallout={showSaleCallout}
						showSavePrice={showSavePrice}
						showJustForYouSaleCallout={showJustForYouSaleCallout}
					/>
				)}

				{isMediaDesktop && showShippingCallout && (
					<ProductItemShippingCallout />
				)}

				{showProductReviewRating && (
					<div className="ProductSortItem__ratingStars">
						<ProductReviewRatingStars rating={product.AverageReviewRating} size="xSmall" />
					</div>
				)}
			</a>

			{showMoreLikeThis && (
				<a
					href={moreLikeThisUrl}
					className="ProductSortItem__moreLikeThisButton"
					rel="nofollow"
				>
					More Like This
				</a>
			)}

			{showAddToCart && (
				<ProductSortItemAddToCartButton shortSku={product.ShortSku} skuInputType={product.SkuInputType} />
			)}
		</div>
	);

}

export default ProductSortItem;
